import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import '@/styles/main.scss'

import { createApp } from 'vue'

import App from './App.vue'
import { vuetify } from './plugins/vuetify'
import { router } from './router'

createApp(App)
  .use(router)
  .use(vuetify)
  .mount('#app')
